import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import api from '../api/axios';
import { formatImageUrl } from '../utils/formatImageUrl';

const getImageUrl = (path) => {
    return formatImageUrl(path, '/assets/images/thumbs/delivery-img1.png');
};

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl text-neutral-800 hover-bg-main-600 hover-text-white transition-1 shadow-sm`}
            style={{ zIndex: 2 }}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl text-neutral-800 hover-bg-main-600 hover-text-white transition-1 shadow-sm`}
            style={{ zIndex: 2 }}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
}

const DeliveryOne = () => {
    const [banners, setBanners] = useState([]);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const res = await api.get('/api/offer-banners?all=true');
                if (res.data && Array.isArray(res.data)) {
                    const activeBanners = res.data
                        .filter(b => b.isActive)
                        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
                    setBanners(activeBanners);
                }
            } catch (err) {
                console.error("Failed to fetch delivery banners", err);
            }
        };
        fetchBanners();
    }, []);

    const sliderSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        pauseOnHover: true,
    };

    const renderBannerItem = (banner) => {
        const bannerImgUrl = getImageUrl(banner.image);
        return (
            <div className="delivery-slide-item">
                <div className="delivery position-relative rounded-16 bg-main-600 flex-align justify-content-center z-1" style={{ overflow: 'hidden' }}>
                    {bannerImgUrl ? (
                        <img
                            src={bannerImgUrl}
                            alt={banner.title || ''}
                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
                            style={{ objectFit: 'cover' }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ) : null}
                    <div className="delivery-content-box text-center">
                        <h4 className="text-white delivery-title mb-6 wow fadeInUp" data-wow-delay="0.2s">
                            {banner.title}
                        </h4>
                        {banner.off && (
                            <p className="text-white delivery-subtitle wow fadeInUp mb-0" data-wow-delay="0.3s">{banner.off}</p>
                        )}
                        <Link
                            to={banner.link || "/shop"}
                            className="mt-12 btn custom-shop-btn fw-medium d-inline-flex align-items-center rounded-pill gap-8 wow fadeInUp hover-lift"
                            data-wow-delay="0.4s"
                            tabIndex={0}
                        >
                            {banner.btnText || "Shop Now"}
                            <span className="icon text-lg d-flex">
                                <i className="ph ph-arrow-right" />
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    };

    // Fallback to static if no dynamic banners are created in Admin yet
    if (banners.length === 0) {
        return (
            <div className="delivery-section py-40">
                <div className="container container-lg">
                    <div className="delivery-slide-item">
                        <div className="delivery position-relative rounded-16 bg-main-600 flex-align justify-content-center z-1" style={{ overflow: 'hidden' }}>
                            <img
                                src="/assets/images/bg/delivery-bg.png"
                                alt=""
                                className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
                                style={{ objectFit: 'cover', borderRadius: '16px' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                }}
                            />
                            <div className="delivery-content-box text-center">
                                <h4 className="text-white delivery-title mb-6">
                                    We Delivery on Next Day from 10:00 AM to 08:00 PM
                                </h4>
                                <p className="text-white delivery-subtitle mb-0">For Orders starts from ₹100</p>
                                <style>
                                    {`
                                        .custom-shop-btn {
                                            background-color: #ffffff !important;
                                            color: #000000 !important;
                                            transition: all 0.3s ease-in-out !important;
                                        }
                                        .custom-shop-btn:hover {
                                            background-color: #176a28 !important;
                                            color: #ffffff !important;
                                        }
                                        .custom-shop-btn:hover .icon {
                                            color: #ffffff !important;
                                        }
                                    `}
                                </style>
                                <Link
                                    to="/shop"
                                    className="mt-12 btn custom-shop-btn fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                                    tabIndex={0}
                                >
                                    Shop Now
                                    <span className="icon text-lg d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <style>
                {`
                    .custom-shop-btn {
                        background-color: #ffffff !important;
                        color: #000000 !important;
                        transition: all 0.3s ease-in-out !important;
                        padding: 7px 18px !important;
                        font-size: 13px !important;
                    }
                    .custom-shop-btn:hover {
                        background-color: #176a28 !important;
                        color: #ffffff !important;
                    }
                    .custom-shop-btn:hover .icon {
                        color: #ffffff !important;
                    }

                    /* Fixed responsive height across all slides */
                    .delivery-slide-item .delivery {
                        height: 200px;
                        min-height: 200px;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        overflow: hidden;
                    }

                    @media (min-width: 576px) {
                        .delivery-slide-item .delivery {
                            height: 220px;
                            min-height: 220px;
                        }
                    }

                    @media (min-width: 768px) {
                        .delivery-slide-item .delivery {
                            height: 250px;
                            min-height: 250px;
                        }
                        .custom-shop-btn {
                            padding: 9px 24px !important;
                            font-size: 14px !important;
                        }
                    }

                    @media (min-width: 992px) {
                        .delivery-slide-item .delivery {
                            height: 280px;
                            min-height: 280px;
                        }
                    }

                    .delivery-content-box {
                        position: relative;
                        z-index: 2;
                        width: 100%;
                        max-width: 680px;
                        padding: 12px 50px;
                    }

                    @media (min-width: 768px) {
                        .delivery-content-box {
                            padding: 20px 70px;
                        }
                    }

                    .delivery-title {
                        font-size: clamp(16px, 4.2vw, 26px);
                        font-weight: 700;
                        line-height: 1.25;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .delivery-subtitle {
                        font-size: clamp(12px, 2.8vw, 15px);
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    /* Slider Arrow Controls */
                    .delivery-slider-wrap .slick-prev,
                    .delivery-slider-wrap .slick-next {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 34px;
                        height: 34px;
                        z-index: 5;
                    }

                    .delivery-slider-wrap .slick-prev {
                        left: 8px;
                    }

                    .delivery-slider-wrap .slick-next {
                        right: 8px;
                    }

                    @media (min-width: 768px) {
                        .delivery-slider-wrap .slick-prev,
                        .delivery-slider-wrap .slick-next {
                            width: 42px;
                            height: 42px;
                        }
                        .delivery-slider-wrap .slick-prev {
                            left: 16px;
                        }
                        .delivery-slider-wrap .slick-next {
                            right: 16px;
                        }
                    }

                    .delivery-slider-wrap .slick-prev:before,
                    .delivery-slider-wrap .slick-next:before {
                        display: none;
                    }
                `}
            </style>
            <div className="delivery-section py-40">
                <div className="container container-lg">
                    {banners.length === 1 ? (
                        // Single banner: display directly without carousel controls
                        renderBannerItem(banners[0])
                    ) : (
                        // Multiple banners: display in carousel with navigation arrows
                        <div className="delivery-slider-wrap position-relative arrow-center">
                            <Slider {...sliderSettings}>
                                {banners.map((banner) => (
                                    <div key={banner.id}>
                                        {renderBannerItem(banner)}
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default DeliveryOne;
